Router = App.loadClass 'core::Router'

class exports.UsernameDropdownRouter extends Router

    prefix: 'UsernameDropdown'
    module_name: 'UsernameDropdownRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'core::Services/UserService', ['$http', '$window']

        @controller 'core::Angular/UsernameDropdown/ContactInfoController', [
            '$q'
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'userData'
            'states'
            'additionalValidation'
            'UsernameDropdown.Services.UserService'
            '$timeout'
            '$window'
            '$ngModal'
        ]

        @controller 'core::Angular/UsernameDropdown/BackgroundController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'UsernameDropdown.Services.UserService'
            'userData'
            'backgroundOptions'
        ]

        @controller 'core::Angular/UsernameDropdown/LocaleController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'userData'
            'locales'
            'UsernameDropdown.Services.UserService'
        ]
